import { adobeAnalyticsScriptsSelector } from '@doda/common/src/redux/features/analytics';
import { tlReadyExecute } from '@doda/common/src/utils/adobeAnalyticsUtil';
import { AnalyticsAppThunk } from '@doda/common/src/types/analytics';
import { RootState } from 'redux/store';

import { AB_TEST_MEASURE_LINK_NAME } from '../../constants';
/**
 * 類似キーワードがある際の求人の計測
 * @param existSimilarKeyword 類似キーワードの存在判定フラグ
 * @returns キーワードタグ求人閲覧AA計測
 */
export const measureSimilarKeywordJob =
  (existSimilarKeyword: boolean): AnalyticsAppThunk<RootState> =>
  (dispatch, getState) => {
    const isAdobeScript = adobeAnalyticsScriptsSelector(getState());
    if (existSimilarKeyword) {
      tlReadyExecute(isAdobeScript, dispatch, 'Matchkeyword_on_etsuran', {});
    } else {
      tlReadyExecute(isAdobeScript, dispatch, 'Matchkeyword_off_etsuran', {});
    }
  };

/**
 * 類似キーワードがある際の気になる押下時の計測
 * @param existSimilarKeyword 類似キーワードの存在判定フラグ
 * @returns キーワードタグ気になるクリックAA計測
 */
export const measureSimilarKeywordFavorite =
  (existSimilarKeyword: boolean): AnalyticsAppThunk<RootState> =>
  (dispatch, getState) => {
    const isAdobeScript = adobeAnalyticsScriptsSelector(getState());
    if (existSimilarKeyword) {
      tlReadyExecute(isAdobeScript, dispatch, 'Matchkeyword_on_favorite', {});
    } else {
      tlReadyExecute(isAdobeScript, dispatch, 'Matchkeyword_off_fovorite', {});
    }
  };

/**
 * 類似キーワードがある際の応募押下時の計測
 * @param existSimilarKeyword 類似キーワードの存在判定フラグ
 * @returns キーワードタグ応募クリックAA計測
 */
export const measureSimilarKeywordApplyJob =
  (existSimilarKeyword: boolean): AnalyticsAppThunk<RootState> =>
  (dispatch, getState) => {
    const isAdobeScript = adobeAnalyticsScriptsSelector(getState());
    if (existSimilarKeyword) {
      tlReadyExecute(isAdobeScript, dispatch, 'Matchkeyword_on_oubo', {});
    } else {
      tlReadyExecute(isAdobeScript, dispatch, 'Matchkeyword_off_oubo', {});
    }
  };

/**
 * AB Test Link Names
 * Mapping of AB test patterns to their respective measurement link names.
 */
const AB_TEST_LINK_NAMES = {
  '1': AB_TEST_MEASURE_LINK_NAME.AB_TEST_ORIGINAL,
  '2': AB_TEST_MEASURE_LINK_NAME.AB_TEST_PATTERN_A,
};

/**
 * Event Type Actions
 * Functions to retrieve the measurement link names based on event types.
 */
const EVENT_TYPE_ACTIONS = {
  bannerDisplayed: () => AB_TEST_MEASURE_LINK_NAME.BANNER_DISPLAYED,
  registerClicked: () => AB_TEST_MEASURE_LINK_NAME.REGISTER_CLICKED,
};

/**
 * Mesure A/B test
 * @param {string} abTestGroupNo - ID A/B test ('1', '2')
 * @param {string} eventType - EventType ('visit', 'bannerDisplayed', 'registerClicked')
 * @returns
 */
export const measureAbTestForRegistSuggestionBanner =
  (abTestGroupNo, eventType): AnalyticsAppThunk<RootState> =>
  (dispatch, getState) => {
    const isAdobeScript = adobeAnalyticsScriptsSelector(getState());
    let customLink = '';

    if (EVENT_TYPE_ACTIONS[eventType]) {
      const result = EVENT_TYPE_ACTIONS[eventType]();
      if (typeof result === 'string') {
        customLink = result;
      }
    } else {
      customLink = AB_TEST_LINK_NAMES[abTestGroupNo];
    }

    if (customLink) {
      tlReadyExecute(isAdobeScript, dispatch, customLink, {});
    }
  };
